import React from 'react'
import styles from "./style.module.css"
import thumb from "../../../assets/images/banner_thumb.png"
import { useNavigate } from "react-router-dom";
import {
  couponVerify,
  createCart,
  getbundles,
  getCountries,
  orderCreate,
} from "../../vfsuk/api";
function Banner() {
  const navigate = useNavigate();
        const handleOpenCountrySelect = () => {
    navigate("/country/select-country");
  };
    return (
        <>
            <div className={styles.globalbanner}>
                <div className="container-fluid">
                    <div className='row align-items-center justify-content-center'>
                        <div className='col-lg-6'>
                            <div className=''>
                                <h3>Travel Smart — eSIM<br/> Lets You Roam Without<br/> the Hassle</h3>
                                <p>Skip the SIM card queues and roaming charges. Activate your<br/> eSIM instantly, stay connected worldwide, and enjoy seamless<br/> internet wherever you go.</p>
                                <button    
                                 onClick={(e) => {
                                    e.preventDefault();
                                    handleOpenCountrySelect();
                                }}>Claim 1GB Data</button>
                            </div>
                        </div>
                        <div className='col-lg-5 offset-lg-1'>
                            <figure>
                                <img src={thumb} alt='' className='img-fluid' />
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Banner